/* eslint-disable max-len */

import { motion } from 'framer-motion'
import React,{lazy, useState,useContext,useRef} from 'react'
import CategoryToolTip from '../../Components/CategoryToolTip'
import { CamelCase, TitleCase } from '../../redux/helper/CamelCase'
import { ExpectedDateGenerator } from '../../redux/helper/DateConverter'
import "react-image-gallery/styles/css/image-gallery.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import ImageGallery from 'react-image-gallery';
import { CDN } from '../../constants'
import "pure-react-carousel/dist/react-carousel.es.css";
import RelatedProducts from './RelatedProducts'
import WishlistHandler from '../../Components/WishlistHandler'
import HeaderContext from '../../Components/Context/HeaderContext'
import { Addtowishlist, WishlistExist } from '../../redux/helper/AddWishlist'
import AddToCart from '../../Components/AddtoCartModal'
import RelatedOffers from './RelatedOffers'
import { PriceHandler } from '../../redux/helper/CamelCase'
import { useNavigate } from 'react-router-dom'

export default function Product({Product,relatedProducts,wishProducts,handlefetch,Cart,setshowRelated,showRelated,relatedOffers}) {
    const imageUrl = Product.IMAGE_NAME?`${CDN}/product-images/${Product.IMAGE_NAME}`:'/images/gen.png';
    const navigate = useNavigate()
    const elRef = useRef(null)
    const scroll = (scrollOffset) => {
        elRef.current.scrollLeft += scrollOffset;
    };
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
    } = useContext(HeaderContext);
    const obj={
        original: imageUrl,
        thumbnail: imageUrl,
    }
    let images = [obj]
    const [hover, sethover] = useState(false);
    const [CartId, setCartId] = useState({})
    const [ModalOpen, setModalOpen] = useState('');
    const [loader, setloader] = useState(false);
    const [selectedItem, setselectedItem] = useState({})


    const handleErrorMessage = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setModalOpen('')
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 1000);
    }
    const handleSuccessMessage = (name,message,diff)=>{
        if(diff===undefined){
            SetSuccessMessage(name);
        }else{
            SetSuccessMessage(`Wishlist ${message}`);
        }
        handlefetch()
        setTimeout(() => {
            SetSuccessMessage('');
            setModalOpen('');
            setcolorValue(false);
            if(diff){
                setModalOpen('popup')
            }
        },1000)
    }
    const handleAddToWishList = (selected,related)=>{
        setloader(true)
        Addtowishlist(selectedItem,selected).then((res)=>{
            if(res.data.success_status){
                setselectedItem({})
                handleSuccessMessage(res.data.message)
            }else{
                handleErrorMessage(res.message.response.data.message)
            }
            setloader(false)
        })
    }
    return (
        <div className="bg-[#FFFFFF] overflow-hidden pb-[22px] md:px-[46px] px-4">
            <p onClick={()=> navigate(-1)} className="text-[#808285] font-normal text-xs13 pt-3 cursor-pointer">
                {Product?.CATEGORY_CONCAT_SEGS.replace(/\./g,' > ')}</p>
            <div className="flex flex-wrap pb-7 pt-3  ">
                <div className="xl:w-[37.5%] lg:w-1/2 w-full lg:pt-0 pt-5 px-3">
                    <div>
                        <ImageGallery 
                            items={images} showBullets={false} showPlayButton={false} autoPlay showNav={false} originalHeight={370} showFullscreenButton={Object.keys(CartId).length===0 ?true:false}/> 
                        <div className="mt-1">
                        </div>
                    </div>
                </div>
                <div className="xl:w-[37.5%] lg:w-1/2 w-full lg:pt-0 pt-5 px-3">
                    <div className="flex items-center">
                        <p className="text-xl font-bold text-[#090406] pr-4">{Product?.MODEL_DESCRIPTION || `${Product?.DESCRIPTION.length > 20 ? `${Product.DESCRIPTION.slice(0,20)}...`:`${Product.DESCRIPTION}`}`}</p>
                        <p className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit">{TitleCase(Product?.MAIN_CATEGORY)}</p>
                        <a href={Product?.LEAFLET} target='_blank' rel="noreferrer"><p className="text-xs font-semibold text-[#090406] pl-4 w-max underline"> Product Leaflet</p></a>
                    </div>
                    <p className="sm:text-sm text-xs2 font-normal text-[#808285] mt-1"><span>Product Code: {Product?.CONCATENATED_SEGMENTS}</span><span className="sm:px-4 px-2">|</span>{Product?.AWS_CLASSIFICATION === null ? null : <span>AWS Classification: {Product?.AWS_CLASSIFICATION}</span>}</p>
                    <div className="pt-[18px]" style={{minHeight:'170px'}}>
                        <p className="text-xs17 font-normal text-[#555259]">{Product?.DESCRIPTION}.</p>
                    </div>
                    <div className="sm:pt-[36px] pt-5 flex sm:flex-row flex-col">
                        <div className="bg-[#EAEAF0] rounded-md sm:pt-2.5 pt-2 sm:pl-2.5 md:pr-[38px] pr-5 px-4 pb-2 sm:w-[30%] w-full">
                            <div className="flex items-center" onMouseEnter={()=>sethover(true)} onMouseLeave={()=>{
                                setTimeout(() => {
                                    sethover(false)
                                }, 1000);
                            }}>
                                <p className="text-xs3-1 font-semibold text-[090406]">Category</p>
                                <p className="text-xs3-1 font-normal text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">{Product?.DELIVERY_LEAD_TIME}</p>
                                <button data-tooltip-target="tooltip-information" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" >
                                    <img src="/images/info_icon.svg" alt="icon" className="cursor-pointer w-[10px]" />
                                </button>
                                {hover && (
                                    <CategoryToolTip hover={true}/>
                                )}
                            </div>
                            <div className="pt-1">
                                <p className="text-xs3-1 font-normal text-[#616874]">Expected Dispatch</p>
                                <p className="text-xs3-1 font-bold text-[#555259] pt-1">{Product?.DELIVERY_LEAD_TIME !==null  && ExpectedDateGenerator(Product?.DELIVERY_LEAD_TIME)}</p>
                            </div>
                            {/* <div className="pt-0.5">
                                <p className="text-xs3-1 font-normal text-[#616874]">Expected Delivery</p>
                                <p className="text-xs3-1 font-bold text-[#555259]"> 27/06/2022</p>
                            </div> */}
                            <div className="pt-2.5">
                                <p className="text-xs3-1 font-normal text-[#616874]">Method of Packing </p>
                                <p className="text-xs3-1 font-bold text-[#555259]">{Product?.METHOD_OF_PACKING}</p>
                            </div>
                        </div>
                        <div className="bg-[#EAEAF0] rounded-md px-4 pt-4 pb-3.5 sm:w-[70%] w-full sm:mt-0 mt-4 sm:ml-2 ml-0">
                            <div className="flex">
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Unit of Measurement</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Product?.PRIMARY_UOM_CODE}</p>
                                </div>
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Minimum Order Quantity</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Product?.MINIMUM_ORDER_QUANTITY || 1} {Product?.PRIMARY_UOM_CODE}</p>
                                </div>
                            </div>
                            <div className="flex pt-4">
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Standard Pack Size</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{Product?.PACKING_SIZE || 1}</p>
                                </div>
                                <div className="w-1/2 pr-1">
                                    <p className="text-xs font-semibold text-[#616874]">Size</p>
                                    <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">{
                                        <>
                                            <>{`${Product?.DIAMETER!==null ?`${Product?.DIAMETER}mm`:''}`}</>
                                            <>{`${Product?.LENGTH!==null && Product?.DIAMETER ? 'x':''}`}</>
                                            <>{`${Product?.LENGTH!==null ?`${Product?.LENGTH}mm`:''}`}</>
                                            <>{Product?.LENGTH===null && Product?.DIAMETER===null ? '-':''}</>
                                        </>
                                    }</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xl:w-[25%] w-full  xl:pt-0 pt-5 px-3 self-end">
                    <div className="sm:px-5 px-4 pt-4 sm:pb-5 pb-4 border border-[#E9EDF4] rounded-[10px]">
                        <div className="flex justify-between items-center pb-3 border-b border-[#E9EDF4]">
                            <p className="text-xs3-1 font-semibold text-[#808285]">Available Stock</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#090406]">{Product.STOCK_VISIBILITY ? <span className="text-[#424446] font-semibold">{Product?.STOCK_ONHAND_QTY} {Product?.PRIMARY_UOM_CODE}</span>:0}</p>
                        </div>
                        <div className="flex justify-between items-center py-3 border-b border-[#E9EDF4]">
                            <p className="text-xs3-1 font-semibold text-[#808285]">List Price</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#090406]">{PriceHandler(Product?.LIST_PRICE)}</p>
                        </div>
                        <button
                            onClick={()=>setCartId(Product)} 
                            className="rounded-lg w-full sm:h-10 h-8 text-sm font-semibold text-[#FFFFFF] bg-[#555259] mt-6" type="button" data-bs-toggle="modal" data-bs-target="#addtocart">
                            {WishlistExist(Cart,Product?.INVENTORY_ITEM_ID)?'Added to Cart!':'Add to Cart'}                        </button>
                        <button
                            onClick={()=>{
                                setModalOpen('popup');
                                setselectedItem(Product)
                            }}
                            className="rounded-lg w-full sm:h-10 h-8 text-sm font-semibold text-[#555259] border border-[#555259] mt-2" type="button" data-bs-toggle="modal" data-bs-target="#addtoWishlistmodal">
                            {WishlistExist(wishProducts,Product?.INVENTORY_ITEM_ID)?'Added to Wishlist!':'Add to Wishlist'}
                        </button>
                    </div>
                </div>
            </div>
            {relatedOffers.length>0 &&<RelatedOffers 
                showRelated={showRelated}
                relatedOffers={relatedOffers}
                setshowRelated={setshowRelated}
            />
            }

            <div className="border-b border-[#E9EDF4] relative mx-12 mt-5">
                <div className="bg-[#FFFFFF] absolute -top-3 left-0 text-[#090406] text-base font-semibold">Related Products</div>
            </div>
            <div className='carousel slide relative mt-3 lg:mb-12 mb-10 heart-symbol'>
                <RelatedProducts 
                    Products={relatedProducts}
                    wishlistProduct={wishProducts}
                    handleAddToWishList={handleAddToWishList}
                    setmodalType={setModalOpen}
                    ModalOpen={ModalOpen}
                    setselectedItem={setselectedItem}
                    Cart={Cart}
                    elRef={elRef}
                    setCartId={setCartId} 
                />
                <button
                    onClick={() => scroll(-200)}
                    className=" z-0 carousel-control-prev absolute top-0 bottom-0 bg-white opacity-100 w-5 flex items-center justify-center p-0 text-center border-0 hover:outline-none hover:no-underline focus:outline-none focus:no-underline -left-1"
                    type="button"
                    style={{height:'85%'}}
                    data-bs-target="#carouselExampleControls2"
                    data-bs-slide="prev"
                >
                    <span className="inline-block bg-no-repeat" aria-hidden="true">
                        <img src="/images/Union-20.svg" alt="icon" className="w-3 h-3"/>
                    </span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    onClick={() => scroll(+200)}
                    className="carousel-control-next z-0  bg-white opacity-100 w-5 absolute top-0 bottom-0 flex items-center justify-center p-0 text-center border-0 -right-2"
                    type="button"
                    style={{height:'100%'}}
                    data-bs-target="#carouselExampleControls2"
                    data-bs-slide="next"
                >
                    <span className="inline-block bg-no-repeat" aria-hidden="true">
                        <img src="/images/chev.svg" />
                    </span>
                    <span className="visually-hidden">Next</span>
                </button>

                {ModalOpen !=='' && <WishlistHandler 
                    setmodalType={setModalOpen}
                    selectedItem={selectedItem}
                    handleAddToWishList={handleAddToWishList}
                    wishlistLoader={loader}
                    wishlistProduct={wishProducts}
                    handleErrorMessage={handleErrorMessage}
                    handleSuccessMessage={handleSuccessMessage}
                />}
            </div>
            <AddToCart product={CartId} isClose={setCartId} handlefetch={handlefetch} Cart={Cart}/>

        </div>
    )
}
